var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Popups'),_c('Notifications'),_c('router-view',{key:_vm.$route.fullPath}),(_vm.$store.state.mainStore.isLoading)?_c('div',{attrs:{"id":"loader"}},[_c('LoadingLogo')],1):_vm._e(),(!_vm.empty(_vm.$store.state.mainStore.imageZoom))?_c('image-zoomer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }